import { useContext } from 'react';
import { notificationState } from '../providers';

const useNotification = () => {
  const context = useContext(notificationState);
  if (!context) {
    throw new Error('context not initialized');
  }
  return context;
};

export default useNotification;
